// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h8pS","colMin":"styles_colMin__1d4fZ"};